import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/shared-files'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'shared_files_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'shared_files_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'shared_files_list',
          meta: {
            featureFlag: FEATURE_FLAGS.SHARED_FILES,
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
